<template>
  <div v-if="content.show">
    <p class="text">{{content.title}}</p>
    <ul class="ui-controlgroup">
      <li v-for="(item,index) in content.answer" class="ui-li-static"  @click="selectCurrent(index,content.num)">
        <div class="li-check">
           <span class="sortnum" v-bind:class="isActive[index] ? 'sortnum-sel':''">{{sort[index]}}</span>
        </div>
        <div class="li-text">
           <span>{{item}}</span>
        </div>
        <div class="clean"></div>
      </li>
    </ul>
    <div class="errorMessage" v-html="content.errorMessage"></div>
  </div>
</template>
<script>
export default {
  props:{
    content: Object
  },
  data (){
    return {
      isActive:[false,false,false,false,false,false],
      sort:[],
      text:''
    }
  },
  methods:{
    selectCurrent:function(index,num){
       const _this = this;let len = 0;
       if(_this.isActive[index]){
          // 点击取消选中时
          _this.$set(_this.isActive, index, false)
          // 大于删除数字的要减一，小于的不用动
          let value=_this.sort[index];
          _this.sort.map(function(item,i){
              if((item-value)>0){
                _this.$set(_this.sort, i, (item-1))
              }
          })
          len = _this.isActive.filter((item)=>{return item==true}).length
          _this.$set(_this.sort, index, '')
       }else{
          // 点击选中时
          _this.$set(_this.isActive, index, true)
          len = _this.isActive.filter((item)=>{return item==true}).length
          _this.$set(_this.sort, index, len)
       }
      // 提示文本信息，默认不显示，选够6个后为空
       let txt = '';
       if(len<6){
          this.content.errorMessage='&nbsp;&nbsp;&nbsp;您已经选择了'+len+'项,少选择了'+(6-len)+'项';
       }
      if(len==6){
          this.content.errorMessage=''
          _this.$emit("listenToChildEvent",num,_this.sort);
       }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .li-check
    position: absolute;
  .li-text
    margin-left:42px;
    font-size:14px;
    padding-top:10px;
</style>
